import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'tran-pill-table',
    template: '<ng-content></ng-content>',
    host: {
        class: 'flex flex-col gap-1 text-xs md:text-base lg:text-copy-l',
        '[attr.data-table-row-classes]': 'rowClasses()'
    },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PillTableComponent {
    public readonly rowClasses = input<string>('');
}
